import React from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { TextField, Typography, withStyles } from "@material-ui/core";
import t from "../../../../../../../languages/pl";
import withSubordinateUser from './../../../../../../HOC/withSubordinateUser';
import CarDamageImage from "./CarDamageImage";

const useStyles = theme => ({
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '550px',
    width: '100%',
  },
  form: {
    marginTop: "16px",
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto 1fr auto',
    columnGap: '3rem'
  },

  damageWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  damageImageWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  damageImage: {
    height: 50,
    width: 50,
    backgroundColor: "grey",
  },
  damageHiddenInput: {
    display: "none",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: '300px'
  }
});

const CarDamageForm = ({ classes, carDamage, onDamageDescriptionChange, onDamageImageChange }) => {

  const getLabel = (name) => {
    const tmp = name.split("_")
      .slice(0, -1)
      .join(" ") || "";
    return tmp.charAt(0).toUpperCase() + tmp.slice(1);
  };

  return (
    <div className={classes.formWrapper}>
      <Typography variant="h6">
        {t.damageList}
      </Typography>
      <div className={classes.form}>
        {carDamage
          .filter(damage => damage.uszkodzony)
          .map((damage, idx) => (
            <div key={`${damage.nazwa}${idx}`} className={classes.damageWrapper}>
              <TextField
                id="standard-multiline-static"
                label={getLabel(damage.nazwa)}
                multiline
                name={damage.nazwa}
                onChange={($event) => onDamageDescriptionChange($event, damage.nazwa)}
                rowsMax="4"
                className={classes.textField}
                margin="normal"
                value={damage.opis}
              />
              <CarDamageImage damage={damage} onDamageImageChange={onDamageImageChange} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default compose(
  withStyles(useStyles),
  withSubordinateUser
)(CarDamageForm);

CarDamageForm.propTypes = {
  classes: PropTypes.object,
  carDamage: PropTypes.array,
  onDamageDescriptionChange: PropTypes.func,
  onDamageImageChange: PropTypes.func,
};
